<template>
    <div class="pagenation">
        <button class="btn btn-prev" @click="turn('prev')" :disabled="pageConfig.page == 1">上一页</button>
        <a :class="['btn-page', pageConfig.page==1 && 'active']"
            @click="toPage(1)">1</a>
        <a class="omit" v-if="pageConfig.page > 4 && pageConfig.totalPage > 7">...</a>
        <a :class="{'btn-page': true, 'active': pageConfig.page == item}"
            v-for="(item, index) in pageConfig.displayPageList"
            @click="toPage(item)"
            :key="index">{{item}}</a>
        <a class="omit"
            v-if="pageConfig.page < pageConfig.totalPage - 3 && pageConfig.totalPage > 7">...</a>
        <a :class="['btn-page', pageConfig.page==pageConfig.totalPage && 'active']"
            v-if="pageConfig.totalPage > 6"
            @click="toPage(pageConfig.totalPage)">{{pageConfig.totalPage}}</a>
        <button class="btn btn-next" @click="turn('next')" :disabled="pageConfig.page == pageConfig.totalPage">下一页</button>
        跳转至
        <input type="number" class="pagenation-input" v-model="to" @keyup.enter="toPage(to)">
        页
        <button class="btn-go pointer" @click="toPage(to)">GO</button>
        <span class="page_total_info">共{{per_page}}页/共{{total_page}}条数据</span>
    </div>
</template>

<script>
export default {
  props: ['total_page', 'per_page', 'current_page'],
  data() {
    return {
        to: this.current_page,
        pageConfig: {
            page: this.current_page,
            records: this.per_page,
            totalRecords: this.total_page,
            size: 3,
            totalPage:this.per_page,
            displayPageList: [2,3,4,5,6,7]
        }
    };
  },
  watch: {
    current_page: {
      handler(val){
        this.pageConfig.page = val;
        this.pageConfig = this.assemblePageTurnerParams(
                                this.pageConfig.records,
                                this.pageConfig.totalRecords,
                                this.pageConfig.page,
                                this.pageConfig.totalPage,
                                this.pageConfig.size)
      }
    },
    total_page: {
      handler(val){
        this.pageConfig.totalRecords = val;
        this.pageConfig = this.assemblePageTurnerParams(
                                this.pageConfig.records,
                                this.pageConfig.totalRecords,
                                this.pageConfig.page,
                                this.pageConfig.totalPage,
                                this.pageConfig.size)
      }
    },
    per_page: {
      handler(val){
        this.pageConfig.totalPage = val;
        this.pageConfig = this.assemblePageTurnerParams(
                                this.pageConfig.records,
                                this.pageConfig.totalRecords,
                                this.pageConfig.page,
                                this.pageConfig.totalPage,
                                this.pageConfig.size)
      }
    }
  },
  mounted(){
      this.pageConfig = this.assemblePageTurnerParams(
                                this.pageConfig.records,
                                this.pageConfig.totalRecords,
                                this.pageConfig.page,
                                this.pageConfig.totalPage,
                                this.pageConfig.size)
  },
  methods: {
    turn(d) {
      if (d == "next") {
        this.pageConfig.page++;
      } else {
        this.pageConfig.page--;
      }
      let pageConfig = this.assemblePageTurnerParams(
                                this.pageConfig.records,
                                this.pageConfig.totalRecords,
                                this.pageConfig.page,
                                this.pageConfig.totalPage,
                                this.pageConfig.size)
      this.pageConfig = pageConfig;
      this.$emit("paginate", this.pageConfig.page);
    },
    toPage(to) {
      if (to > this.pageConfig.totalPage) {
        this.$message({ type: "error", message: "无此页数" });
        return;
      }
      this.pageConfig.page = to;
      let pageConfig = this.assemblePageTurnerParams(
                                this.pageConfig.records,
                                this.pageConfig.totalRecords,
                                this.pageConfig.page,
                                this.pageConfig.totalPage,
                                this.pageConfig.size)
      this.pageConfig = pageConfig;

      this.$emit("paginate", this.pageConfig.page);
    },
    assemblePageTurnerParams(
        records,
        totalRecords,
        currentPage,
        totalPage,
        size
    ){
        var records = records;
        var totalRecords = totalRecords;
        var currentPage = currentPage;
        var totalPage = totalPage;
        var size = size;
        var displayPageList = [];

        var firstPage = "";
        //第一页时 翻上页
        if (currentPage < 1) {
            currentPage = 1;
        }
        //最后一个 翻下页
        else if (currentPage > totalPage) {
            currentPage = totalPage;
        }

        //总页数小于7页
        if (totalPage < 7) {
            for (var j = 2; j <= totalPage; j++) {
                displayPageList.push(j);
            }
        }
        //总页数大于等于7页
        else {
            if (currentPage < 5) {
            firstPage = 2;
            }
            // else if (currentPage<6){
            // console.log('点击的页面小于6')
            // firstPage = 3
            // }
            else if (currentPage > totalPage - 3) {
            firstPage = totalPage - 5;
            } else {
            firstPage = currentPage - 2;
            }

            for (var i = firstPage; i < firstPage + 5; i++) {
            displayPageList.push(i);
            }
        }

        var params = {
            records: records,
            totalRecords: totalRecords,
            page: currentPage,
            totalPage: totalPage,
            size: size,
            displayPageList: displayPageList
        };
        return params;
    }
  }
};


</script>

<style lang="scss" scoped>
.pagenation {
  background: #fff;
  text-align: center;
  height: 70px;
  line-height: 70px;
  width: 100%;
  margin: 0 auto;
  // margin-top: 10px;
  // margin-bottom: 10px;
  font-size: 14px;
  user-select: none;
  position:fixed;
  bottom:0px;
  left: 20px;
  // left: 16.7%;
}
.pagenation .btn {
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
}
.pagenation {
  .page_total_info {
    padding: 0 20px;
  }
  .btn-page {
   // vertical-align: top;
    display: inline-block;
    width: 35px;
    line-height: 35px;
    height: 35px;
    background: #ffffff;
    border:1px solid #C4C4C4;
    color: black;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 10px;
    cursor: pointer;
  }
  .omit {
   // vertical-align: top;
    display: inline-block;
    width: 35px;
    line-height: 35px;
    height: 35px;
    background: transparent;
    color: black;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 10px;
     border:1px solid #C4C4C4;
    cursor: pointer;
  }
  .active {
    background: #264689;
    color: white;
  }
  .btn-prev,
  .btn-next {
    background: #ffffff;
    width: 65px;
    height: 35px;
    text-align: center;
    border-color: #C4C4C4;
  }

  .btn-prev[disabled="disabled"],
  .btn-next[disabled="disabled"] {
    color: #dfdee4;
    cursor: not-allowed;
  }
  .pagenation-input {
    width: 34px;
    height: 34px;
    border: 1px solid #999999;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
   // vertical-align: top;
    margin: 0 10px;
  }
  .btn-next,
  .btn-prev {
    margin-right: 10px;
  }
  .btn-go {
    width: 35px;
    height: 35px;
    line-height: 35px;
    background: #264689;
    color: #fff;
    border: none;
    border-radius: 4px;
  //  vertical-align: top;
  }
}
</style>




// WEBPACK FOOTER //
// src/component/base-pagination.vue